import React from 'react'

import Section from '../Section'
import { Row, Col } from 'components/Layout'
import Markdown from 'features/Markdown'

import s from './Col2TextText.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
  >
    <Row className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
      <Col className={cn(sLay['flex-gt-xs'], s.centerOnMobile)}>
        <Markdown text={props.text1} color={props.color} />
      </Col>
      <Col className={cn(s.col2, s.centerOnMobile, sLay['flex-gt-xs'])}>
        <Markdown text={props.text2} color={props.color} />
      </Col>
    </Row>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col2TextText/Col2TextText.jsx